import { render, staticRenderFns } from "./list-history.vue?vue&type=template&id=d1a64ef4&scoped=true"
import script from "./list-history.vue?vue&type=script&lang=js"
export * from "./list-history.vue?vue&type=script&lang=js"
import style0 from "./list-history.vue?vue&type=style&index=0&id=d1a64ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a64ef4",
  null
  
)

export default component.exports